import { fetchContacts } from '#action/addressbook/addressbook-contacts-paginated';
import { uuidv4 } from '#helper';

const searchProps = {
  type: 'Search',
  name: 'search',
  label: 'Search a contact',
  relatedTo: 'addressbook',
  id: uuidv4()
};

const filterConfig = {
  customActions: {
    fetchFilterData: fetchContacts
  },
  searchProps
};

export default filterConfig;
